var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#FFF","fillRule":"evenodd"},[React.createElement("path",{"d":"M11.357 11.05l5.523 4.832c.142.125.16.312.041.417l-.722.632c-.12.104-.334.089-.476-.036L10.2 12.063","key":0}),React.createElement("path",{"d":"M10.394 10.394a5.083 5.083 0 1 1-7.19-7.188 5.083 5.083 0 0 1 7.19 7.188M1.992 1.992a6.8 6.8 0 1 0 9.616 9.616 6.8 6.8 0 0 0-9.616-9.616","key":1})]));
}

Search.defaultProps = {"viewBox":"0 0 17 17"};

module.exports = Search;

Search.default = Search;
